import Badge from '@/components/base/badge/badge';
import Button from '@/components/base/button/button';
import PhosphorIcon from '@/components/base/icon/phosphor-icon';
import type { Icon } from '@phosphor-icons/react';
import { clsx } from 'clsx';

interface Props {
  text: string;
  redirect: string;
  icon: Icon;
  badgeNumber?: number;
  type?: 'favorite' | 'default';
  testId?: string;
}

export const NavElement = ({
  icon,
  redirect,
  text,
  badgeNumber,
  type = 'default',
  testId,
}: Props) => {
  return (
    <Button
      variant="tertiary-no-frame"
      className="h-full l:h-clickable l:w-max s:w-clickable w-clickable-minimum xs:w-[42px] l:px-s"
      isLink
      aria-label={text}
      href={redirect}
      testId={testId}
    >
      <div
        className="relative h-icon-medium w-icon-medium s:max-l:h-icon-large s:max-l:w-icon-large"
        data-target={type === 'favorite' && 'animate-heart'}
      >
        {/* We need additional element that will be cloned and animated */}
        {type === 'favorite' && (
          <PhosphorIcon
            Icon={icon}
            variant="fill"
            className="icon-m s:icon-l l:icon-m invisible absolute w-auto fill-brand"
            data-target="clone-animate-heart"
          />
        )}
        <PhosphorIcon
          Icon={icon}
          variant="regular"
          className="icon-m s:icon-l l:hidden w-auto fill-strong"
        />
        <PhosphorIcon
          Icon={icon}
          variant="bold"
          className="l:icon-m l:block hidden w-auto l:fill-brand stroke-2"
        />
        <span
          className={clsx(
            !badgeNumber && 'hidden',
            's:max-l:-right-3 absolute top-[-9px] right-[-7px] s:max-l:top-[-8px]',
          )}
        >
          <Badge
            accented
            behavior="second"
            size="small"
            num={badgeNumber}
            testId="badge"
            className="box-content border border-white"
          />
        </span>
      </div>

      <span className="l:flex hidden font-normal text-body">{text}</span>
    </Button>
  );
};
